import React, { useContext, useMemo } from "react";
import { useRawData } from "../RawData/useRawData";
import StaticErrorFallback from "../../../../Components/ErrorFallback/StaticErrorFallback";
import JsonView from "@uiw/react-json-view";
import { githubLightTheme } from "@uiw/react-json-view/githubLight";
import { githubDarkTheme } from "@uiw/react-json-view/githubDark";
import {
  IconButton,
  useChangeTooltipMsg,
  Loader,
  useIcon,
} from "@SeemplicityDev/shared";
import "./AdditionalData.scss";
import {
  GeneralAppContext,
  THEMES_NAMES,
} from "../../../../General/GeneralAppProvider";

const FindingRawData: React.FC = () => {
  const { getSvg } = useIcon();
  const { rawData, loadingRawData } = useRawData({
    isRaw: false,
  });
  const { copyMsg, setCopyMsg } = useChangeTooltipMsg("Copy", "Copied!");
  const {
    appContext: { currentTheme },
  } = useContext(GeneralAppContext);
  const theme = useMemo(
    () =>
      currentTheme === THEMES_NAMES.DARK ? githubDarkTheme : githubLightTheme,
    [currentTheme]
  );
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {loadingRawData ? (
        <Loader
          center
          img={getSvg("icon-spinner")}
          iconSize={"xxxxl"}
          fullViewportHeight
          title={"Loading raw data"}
          subtitle={"This may take a few minutes"}
        />
      ) : !!rawData ? (
        <JsonView
          value={rawData as object}
          displayObjectSize={false}
          displayDataTypes={false}
          shortenTextAfterLength={0}
          style={theme}
        >
          <JsonView.Copied
            render={({ onClick, ...props }) => {
              return (
                <IconButton
                  isIcon="seem-icon-copy"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    onClick?.(e as unknown as React.MouseEvent<SVGSVGElement>);
                    setCopyMsg("Copied!");
                  }}
                  size="xs"
                  withTooltip={{
                    content: copyMsg,
                  }}
                  wrapperClassName="raw-data-copy-button"
                />
              );
            }}
          />
        </JsonView>
      ) : (
        <StaticErrorFallback
          error={{ message: "Error Loading Data" }}
          buttons={[]}
        />
      )}
    </div>
  );
};

export default FindingRawData;
